export default {"src":"/_next/static/media/ml-dashboard-mobile.5f63c091.svg","height":311,"width":375,"blurWidth":0,"blurHeight":0};